module.exports = __webpack_public_path__ + "img/admin.33878c46.svg";